
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontactochambmetro46fke } from '../../api/contactochambmetro46fke.api'

import './chambometroelectoralfz8nx.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pchambometroelectoralfz8nx = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id690fe0f98e5aed52dc8508c7" >

      <div id="ii5j" className="">
      
      <div id="i2wm" className="">
      
      <div id="i3to" className="">
      
      <div id="i4zac" className="">
      
      <div id="i7aeb1" className="">
      
      <div id="iq3oci" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="iyoins"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="iqxn7c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iup45h"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="iyzeef"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="if3occ"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="i3pbhl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="irgcil"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iro1nx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i6t911" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="istkj" className="">
      
      <div id="ivpj2" className="">
      
        <LoftyDropdownComponent
          id="icbbua"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="itt4vg" className="gjs-dropdown-menu-trigger link-navegacion ">
<>Ecosistema chamba
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="iuszyo" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navegacion "
          id="i0llh"
          href="/index"
        >
          
    <div id="ij1vq" className="">
    <>Chamba Index</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="izecgz"
          href="/chambanomics"
        >
          
    <div id="ii8xzy" className="">
    <>Chambanomics</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="i68lj"
          href="/chambometro"
        >
          
    <div id="inisp" className="">
    <>Chambómetro Electoral</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="iog9i6"
          href="/talks"
        >
          
    <div id="iogkoj" className="">
    <>Chamba talks</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ievl0d"
          href="/chambeador"
        >
          
    <div id="i40bdb" className="">
    <>Chambeador del año</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className="link-navegacion "
          id="ilnkvn"
          href="/fundacion"
        >
          
    <div id="iv451u" className="">
    <>Fundación</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="iaa1w" className="">
      
        <a
          target=""
          className=""
          id="itud73"
          href="/"
        >
          
      <img
        className=""
        id="ilkbh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4z2t" className="">
      
        <a
          target=""
          className="link-navegacion "
          id="ixf4dl"
          href="/sobrenosotros"
        >
          
    <div id="ijolgi" className="">
    <>Sobre Nosotros</>
    </div>
    
        </a>
        
        <a
          target="_blank"
          className="link-navegacion "
          id="ib3hct"
          href="https://cne.chamba.hn/"
        >
          
    <div id="i7mcmj" className="">
    <>Centro electoral</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i23lgf" className="">
      
      <img
        className=""
        id="iaxk7b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/index"
        type=""
      >
        <>Chamba Index</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambanomics"
        type=""
      >
        <>Chambanomics</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/talks"
        type=""
      >
        <>Chamba Talks</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/fundacion"
        type=""
      >
        <>Fundación</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambometro"
        type=""
      >
        <>Chambómetro</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambeador"
        type=""
      >
        <>Chambeador del año</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="isa7id"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="i9x2g" className="">
      
      <div id="ir0hzi" className="">
      
      <div className="" id="im8zk">
        <>Chambómetro Electoral</>
      </div>
      
      <div className="" id="il360e">
        <>Descubre cuál plan de gobierno genera más empleo</>
      </div>
      
        <a
          target="_blank"
          className=""
          id="im6abk"
          href="https://chambahntwggb.loftyappsbackoffice.com/api/archivosdechambometrowxai/file/lofty/local/e349f45dc7f0b780737517f2c922e3e2.pdf"
        >
          
      <span className="" id="izpqcq">
        <>Haz clic aquí</>
      </span>
      
        </a>
        <>
        </>
      </div>
      
      <div id="iwtz5n" className="">
      
        <div className="" id="iuegr3">
          
      <form
        id="i62zn5"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontactochambmetro46fke({
						token: 'aasdas',
						dniqf9ni: e.target.dniqf9ni?.value,
						nombrefby5q: e.target.nombrefby5q?.value,
						correor297r: e.target.correor297r?.value,
					});
					window.location.href = `/exitoso/chambometro`;
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div className="" id="i8ltut">
        <>Suscríbete</>
      </div>
      
      <div className="" id="ildqfh">
        <>Unite al Chambómetro Electoral y conocé cómo piensan, sienten y reaccionan los hondureños ante el momento político actual.</>
      </div>
      
      <div id="ihntf9" className="">
      
      <label id="" className="">
      <>DNI</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="dniqf9ni"
        type="text"
        placeholder="0801199715378"
        className="input "
        id="iuzgul"
      />
      
      </div>
      
      <div id="i6xk5f" className="">
      
      <label id="" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombrefby5q"
        type="text"
        placeholder="Pedro Cruz"
        className="input "
        id="i74wtf"
      />
      
      </div>
      
      <div id="img73c" className="">
      
      <label id="" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correor297r"
        type="text"
        placeholder="correo@ejemplo.com"
        className="input "
        id="ijfmb9"
      />
      
      </div>
      
      <div id="i25kwv" className="">
      
      <button
        type="submit"
        name=""
        id="ia7a0k"
        className=""
        
      >
      
      <div id="ivj328" className="">
      <>Suscribirse Ahora</>
      </div>
      
      </button>
      <>
        </>
      </div>
      
      </form>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8g6" className="">
      
      <img
        className=""
        id="izriq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxjnni.png"
        alt="undefined"
      />
      
      <div
        id="i9enf4"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i7inz" className="">
      
      <div className="" id="ijluj">
        <>Indicadores clave que mediremos</>
      </div>
      
      <div className="" id="i1tx6z">
        <>Es una herramienta innovadora que mide el clima político, económico y social de Honduras mes a mes, transformando datos complejos en información que se puede sentir y comprender.</>
      </div>
      <>
        </>
      </div>
      
      <div
        id="iqta8m"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div
        id="igrft3"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="iqblng" className="">
      
      <img
        className="img-tarjeta-programa "
        id="id24nj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqn852x.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="igae78" className="">
      
      <div className="titulo-tarjeta-programa " id="isehhf">
        <>Empleo e informalidad</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="iaodri">
        <>Tasa de empleo formal e índice de informalidad laboral</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ijgroi"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i28x7q" className="">
      
      <img
        className="img-tarjeta-programa "
        id="i8orti"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqn8q3r.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i9ewfi" className="">
      
      <div className="titulo-tarjeta-programa " id="iunkh5">
        <>Coste de Vida</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="im7ece">
        <>Índice de costo de vida y poder adquisitivo</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="isl4ma"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ivtxjk" className="">
      
      <img
        className="img-tarjeta-programa "
        id="icyack"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqn9ncj.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i4mwl1" className="">
      
      <div className="titulo-tarjeta-programa " id="i9fa25">
        <>Expectativas Empresariales</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="iq738b">
        <>Confianza del sector privado y proyecciones de crecimiento</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="iomhbr"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="idfojm" className="">
      
      <img
        className="img-tarjeta-programa "
        id="iceykf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqn9ncj.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i196pj" className="">
      
      <div className="titulo-tarjeta-programa " id="i4bc42">
        <>Sentimiento Social</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="if0fry">
        <>Percepción ciudadana sobre el futuro y bienestar</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="iva2yi"
        className="tarjeta-programa "
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i90ogy" className="">
      
      <img
        className="img-tarjeta-programa "
        id="iohml6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqn9ncj.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="io73ah" className="">
      
      <div className="titulo-tarjeta-programa " id="ixynqj">
        <>Estabilidad Política</>
      <br className="" id="" />
      
      </div>
      
      <div className="descripcion-tarjeta-programa " id="inn4d4">
        <>Índice de estabilidad política y gobernabilidad</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="i68z7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxlys4.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i6yyhl" className="">
      
      <div
        id="ih6eoa"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="" id="iw3bdm">
        <>CAMBIANDO UNA GENERACIÓN</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iydme9">
        <>Creemos que los hondureños somos más fuertes cuando trabajamos juntos. Únete a nuestra plataforma ciudadana que promueve el empleo y la libertad.</>
      </div>
      
      <div id="isg2x7" className="">
      
        <a
          target=""
          className="boton-principal "
          id="idam18"
          href="/contacto"
        >
          
      <span className="" id="i4irhj">
        <>Únete ahora</>
      </span>
      
        </a>
        <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="izwmsw" className="">
      
      <div id="ilyx6r" className="">
      
      <div id="i9wsm7" className="">
      
      <div id="ihb2p" className="">
      
      <div id="ivm8j" className="item-text ">
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <img
        className=""
        id="izaouj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhqa0t2u.png"
        alt="undefined"
      />
      
      <div
        id="ib1cd8"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i3b317" className="">
      
      <div className="" id="ivlcnl">
        <>A través de la recopilación y análisis de datos socioeconómicos, el Chambómetro Electoral brindará una visión clara y accesible del estado del país, permitiendo a ciudadanos, empresas y organizaciones tomar decisiones informadas.</>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="im78" className="">
      
      <div id="imr134" className="">
      
      <div id="i3kmzi" className="">
      
      <img
        className=""
        id="ijd9oi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div className="" id="ixapj1">
        <>En CHAMBA creemos que el verdadero cambio comienza cuando las personas tienen oportunidades reales. No hablamos de discursos, hablamos de empleo, educación responsabilidad fiscal, libre mercado y gobierno limitado. Nuestro propósito es conectar a los hondureños que quieren salir adelante con las herramientas, la información y las redes que pueden hacerlo posible.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="igpnrp" className="">
      
      <div className="" id="iwmzhr">
        <>Siguenos</>
      </div>
      
      <div id="ii0mf" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="igd3x"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="ivqnc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="i5j0k"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="ibnrn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="ir76u"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="imcck"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="izuti"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iyz7f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="id4zm3">
        <>© 2025 CHAMBA. Todos los derechos reservados.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pchambometroelectoralfz8nx);
  